export default __webpack_public_path__ + "static/media/Treating-Customers-Fairly-2025.c715073d.pdf";